import Topbar from "../component/nav/TopBar";

export default function AdminLayout({ children }) {
  return (
    <div className="admin-shell">
      <Topbar />
      <main className="admin-main">{children}</main>
    </div>
  );
}
